import PersonaList from './PersonaList'
export {PersonaList}
export default PersonaList
